<fury-loading-overlay [isLoading]="isLoading" [fill]="true"></fury-loading-overlay>
<div fxFlex fxLayout="column" fxLayoutAlign="space-between">
  <div class="task-panel-header" fxLayoutAlign="space-between center">
    <h1>
      <ng-container *ngIf="taskPanelService.editorType === 'create'">Nieuwe taak</ng-container>
      <ng-container *ngIf="taskPanelService.editorType === 'update' && task">
        {{ task.number }} -
        <span [style.background]="task.status.color" class="status-color">{{ task.status.display_name }}</span>
      </ng-container>
      <ng-container *ngIf="taskPanelService.editorType === 'update' && !task && !isLoading">
        Geen taak gevonden!
      </ng-container>
    </h1>
    <div>
      <fury-page-header-buttons [buttons]="topButtons"></fury-page-header-buttons>
    </div>
  </div>
  <fury-alert-box *ngIf="task && (taskWebhookService.taskUpdated | async)?.id === task.id" class="warn with-button without-border-radius">
    <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutAlign="center center" fxLayoutAlign.gt-sm="space-between center">
      Een andere gebruiker heeft deze taak aangepast, ververs de taak voordat uw aanpassingen gaat maken.
      <div>
        <button (click)="refresh(task.id)" class="mat-button mat-red" mat-flat-button type="button">
          <mat-icon>refresh</mat-icon>
          Verversen
        </button>
      </div>
    </div>
  </fury-alert-box>
  <fury-alert-box *ngIf="task && (taskWebhookService.taskDeleted | async)?.id === task.id || task?.is_deleted" class="warn">
    Deze taak is verwijderd.
  </fury-alert-box>
  <mat-tab-group #tabGroup (selectedTabChange)="tabChanged($event)"
                 *ngIf="taskPanelService.editorType === 'update' && task || taskPanelService.editorType === 'create'"
                 class="quickpanel fury-tabs" fxFlex mat-stretch-tabs
                 [class.hide-header]="taskPanelService.editorType === 'create'">
    <form (ngSubmit)="save()" [formGroup]="form">
      <mat-tab label="TAAK">
        <ng-template mat-tab-label >
          TAAK
          <mat-icon *ngIf="tabWarning.includes('taak') && task?.closed_at === null">warning</mat-icon>
        </ng-template>
        <fury-scrollbar class="overflow-container">
          <div class="task-panel-body" fxLayout="column">
            <ng-container *ngIf="task && !editCurrentTask">
              <div class="task-view-header">
                <h2 class="title">Taakgegevens</h2>
                <button *ngIf="['resolved', 'rejected'].indexOf(task.status.name) === -1 && !task.is_deleted" mat-button (click)="toggleTaskEditing()">
                  <mat-icon>edit</mat-icon>
                  Bewerken
                </button>
              </div>
              <div class="task-view-details">
                <fury-alert-box *ngIf="task.outside_of_known_tiles" class="info">
                  <mat-icon>warning</mat-icon>
                  <strong>Let op!</strong> Deze taak bevindt zich buiten de tegels.
                </fury-alert-box>
                <dl>
                  <dt>Taaknummer:</dt>
                  <dd>{{ task.number }}</dd>
                </dl>
                <dl>
                  <dt>Startdatum & tijd:</dt>
                  <dd>{{ task.created_at | date:'dd-MM-yy HH:mm' }}</dd>
                </dl>
                <dl>
                  <dt>Einddatum & tijd:</dt>
                  <dd>
                    <div class="closed-at">
                      <span>{{ task.closed_at | date:'dd-MM-yy HH:mm' }}</span>
                      <div class="task-handling-days">
                        <span *ngIf="task.handling.handled_days > 0">
                          <span class="handling_days">
                            <span *ngFor="let items of taskService.handlingDaysRange(task.handling.handling_days, task.handling.handled_days); let i = index;"
                                  class="days{{i}}"></span>
                          </span>
                          <span class="handling_text" [class.red]="task.handling.handled_days > task.handling.handling_days">
                            {{ task.handling.handled_days }} dag<span *ngIf="task.handling.handled_days > 1">en</span>
                          </span>
                        </span>
                      </div>
                    </div>
                  </dd>
                </dl>
                <dl>
                  <dt>Prioriteit:</dt>
                  <dd>{{ task.priority.display_name }}</dd>
                </dl>
                <dl>
                  <dt>Status:</dt>
                  <dd>{{ task.status.display_name }}</dd>
                </dl>
                <dl>
                  <dt>Toegekend aan:</dt>
                  <dd>{{ task.assigned_user?.name }}</dd>
                </dl>
                <dl>
                  <dt>Tegel:</dt>
                  <dd>{{ task.tile?.name }}</dd>
                </dl>
                <dl>
                  <dt>Coördinaten:</dt>
                  <dd>X: {{ task.new_rd_lat }}, Y: {{ task.new_rd_lng }}</dd>
                </dl>
                <dl>
                  <dt>Adres:</dt>
                  <dd>{{ task.streetname }} {{ task.house_number }}{{ task.house_number_addition }}, {{ task.city }}</dd>
                </dl>
                <dl>
                  <dt>Basis registratie:</dt>
                  <dd>{{ task.basic_registration.name }}</dd>
                </dl>
                <dl>
                  <dt>Taak:</dt>
                  <dd>{{ task.task_registration?.name }}</dd>
                </dl>
                <dl>
                  <dt>Bron:</dt>
                  <dd>{{ task.source?.name }}</dd>
                </dl>
                <dl>
                  <dt>Actie:</dt>
                  <dd>{{ task.action?.name }}</dd>
                </dl>
                <dl>
                  <dt>Strom:</dt>
                  <dd>{{ task.current?.name }}</dd>
                </dl>
                <dl>
                  <dt>Invloed registratie:</dt>
                  <dd>{{ task.impact_registration?.name }}</dd>
                </dl>
                <dl>
                  <dt>Zaak:</dt>
                  <dd>{{ task.outside_number }}</dd>
                </dl>
              </div>
            </ng-container>
            <ng-container *ngIf="taskPanelService.editorType === 'create' || taskPanelService.editorType === 'update' && task && editCurrentTask">
              <div class="task-view-header">
                <h2 class="title">Taak bewerken</h2>
              </div>
              <mat-form-field #f1 [matTooltip]="getTooltipText(f1)" *ngIf="taskPanelService.editorType !== 'create'">
                <mat-label>Taaknummer</mat-label>
                <input matInput [formControl]="form.controls.number" placeholder="Taaknummer">
                <mat-error *ngIf="formService.getFieldError('number')">
                  {{ formService.getFieldError('number') }}
                </mat-error>
              </mat-form-field>
              <mat-form-field #f2 [matTooltip]="getTooltipText(f2)">
                <mat-label>Startdatum & tijd</mat-label>
                <input matInput [mtxDatetimepicker]="createdAtPicker" [formControl]="form.controls.created_at" readonly (click)="createdAtPicker.open()">
                <mtx-datetimepicker #createdAtPicker></mtx-datetimepicker>
                <mat-error *ngIf="formService.getFieldError('created_at')">
                  {{ formService.getFieldError('created_at') }}
                </mat-error>
              </mat-form-field>
              <mat-form-field #f4 [matTooltip]="getTooltipText(f4)">
                <mat-label>Prioriteit</mat-label>
                <mat-select [formControl]="form.controls.priority_id" placeholder="Prioriteit" required>
                  <mat-option *ngFor="let data of filters.priorities.data" [value]="data.id">
                    {{ data.display_name }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="formService.getFieldError('priority_id')">
                  {{ formService.getFieldError('priority_id') }}
                </mat-error>
                <mat-spinner *ngIf="filters.priorities.isLoading" diameter="20"></mat-spinner>
              </mat-form-field>
              <mat-form-field #f5 [matTooltip]="getTooltipText(f5)">
                <mat-label>Status</mat-label>
                <mat-select [formControl]="form.controls.status_id" placeholder="Status" required>
                  <mat-option *ngFor="let data of filters.statuses.data" [value]="data.id">
                    {{ data.display_name }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="formService.getFieldError('status_id')">
                  {{ formService.getFieldError('status_id') }}
                </mat-error>
                <mat-spinner *ngIf="filters.statuses.isLoading" diameter="20"></mat-spinner>
              </mat-form-field>
              <mat-form-field #f6 [matTooltip]="getTooltipText(f6)">
                <mat-label>Toegekend aan</mat-label>
                <mat-select [formControl]="form.controls.assigned_user_id" placeholder="Toegekend aan" required>
                  <mat-option *ngFor="let data of filters.users.data" [value]="data.id">
                    {{ data.name }}
                    <ng-container *ngIf="data.department">({{ data.department.name })</ng-container>
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="formService.getFieldError('assigned_user_id')">
                  {{ formService.getFieldError('assigned_user_id') }}
                </mat-error>
                <mat-spinner *ngIf="filters.users.isLoading" diameter="20"></mat-spinner>
              </mat-form-field>
              <mat-form-field #f7 [matTooltip]="getTooltipText(f7)">
                <mat-label>Tegel</mat-label>
                <mat-select [formControl]="form.controls.tile_id" placeholder="Tegel" required>
                  <mat-option *ngFor="let data of filters.tiles.data" [value]="data.id">
                    {{ data.name }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="formService.getFieldError('tile_id')">
                  {{ formService.getFieldError('tile_id') }}
                </mat-error>
                <mat-spinner *ngIf="filters.tiles.isLoading" diameter="20"></mat-spinner>
              </mat-form-field>
              <div fxFlex fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="0px" fxLayoutGap.gt-xs="22px">
                <mat-form-field fxFlex="100" fxFlex.gt-xs="45" #f8 [matTooltip]="getTooltipText(f8)">
                  <mat-label>X coördinaten</mat-label>
                  <input matInput [formControl]="form.controls.new_rd_lat" placeholder="X coördinaten">
                  <mat-error *ngIf="formService.getFieldError('new_rd_lat')">
                    {{ formService.getFieldError('new_rd_lat') }}
                  </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="100" fxFlex.gt-xs="45" #f8 [matTooltip]="getTooltipText(f8)">
                  <mat-label>Y coördinaten</mat-label>
                  <input matInput [formControl]="form.controls.new_rd_lng" placeholder="Y coördinaten">
                  <mat-error *ngIf="formService.getFieldError('number')">
                    {{ formService.getFieldError('number') }}
                  </mat-error>
                </mat-form-field>
                <div fxFlex="100" fxFlex.gt-xs="10">
                  <button mat-icon-button matTooltip="Select location on the map" (click)="selectTaskLocation()">
                    <mat-icon>add_location</mat-icon>
                  </button>
                </div>
              </div>
              <fury-alert-box *ngIf="coordinatesAreOutsideTile" class="info">
                <mat-icon>info</mat-icon>
                De geselecteerde coördinaten liggen buiten de geselecteerde tegel.
                <ng-container *ngIf="coordinatesAreOutsideTile === true">Bij het opslaan wordt de juiste tegel aan deze taak gekoppeld.</ng-container>
                <ng-container *ngIf="coordinatesAreOutsideTile !== true">
                  Correct tile is {{ coordinatesAreOutsideTile.name }}. Would you like to <a (click)="updateTileId(coordinatesAreOutsideTile)">update your
                  selection</a>?
                </ng-container>
              </fury-alert-box>
              <mat-form-field #f10 [matTooltip]="getTooltipText(f10)">
                <mat-label>Adres</mat-label>
                <input [formControl]="form.controls.address" matInput placeholder="Adres">
                <mat-error *ngIf="formService.getFieldError('address')">
                  {{ formService.getFieldError('address') }}
                </mat-error>
              </mat-form-field>
              <div class="address-dropdown-position" fxLayout="column">
                <fury-alert-box *ngIf="searchTaskLocationsTimedOut" class="info">
                  Locatie zoeker is momenteel niet beschikbaar, probeer het zo nogmaals.
                </fury-alert-box>
                <fury-alert-box *ngIf="searchTaskLocationsNoResults" class="info">
                  Er zijn geen resultaten gevonden, probeer een ander adres.
                </fury-alert-box>
                <div class="address-dropdown-container">
                  <div *ngIf="searchTaskLocations.length" class="address-dropdown">
                    <div>
                      <p>Er zijn verschillende adressen gevonden, selecteer de correcte locatie:</p>
                      <button (click)="searchTaskLocations.length = 0" mat-icon-button>
                        <mat-icon>close</mat-icon>
                      </button>
                    </div>
                    <mat-selection-list dense multiple="false">
                      <mat-list-option (click)="selectTaskAddress(address.id)" *ngFor="let address of searchTaskLocations">
                        {{ address.weergavenaam }}
                      </mat-list-option>
                    </mat-selection-list>
                  </div>
                </div>
                <fury-loading-overlay [isLoading]="searchTaskLocationsIsLoading"></fury-loading-overlay>
              </div>
              <mat-form-field #f11 [matTooltip]="getTooltipText(f11)">
                <mat-label>Basis registratie</mat-label>
                <mat-select [formControl]="form.controls.basic_registration_id" placeholder="Basis registratie">
                  <mat-option *ngFor="let basicRegistration of filters.basicRegistrations.data" [value]="basicRegistration.id">
                    {{ basicRegistration.name }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="formService.getFieldError('basic_registration_id')">
                  {{ formService.getFieldError('basic_registration_id') }}
                </mat-error>
                <mat-spinner *ngIf="filters.basicRegistrations.isLoading" diameter="20"></mat-spinner>
              </mat-form-field>
              <mat-form-field #f12 [matTooltip]="getTooltipText(f12)">
                <mat-label>Taak</mat-label>
                <mat-select [formControl]="form.controls.task_registration_id" placeholder="Taak">
                  <mat-option *ngFor="let taskRegistration of filters.taskRegistrations.data" [value]="taskRegistration.id">
                    {{ taskRegistration.name }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="formService.getFieldError('task_registration_id')">
                  {{ formService.getFieldError('task_registration_id') }}
                </mat-error>
                <mat-spinner *ngIf="filters.taskRegistrations.isLoading" diameter="20"></mat-spinner>
              </mat-form-field>
              <mat-form-field #f13 [matTooltip]="getTooltipText(f13)">
                <mat-label>Bron</mat-label>
                <mat-select [formControl]="form.controls.source_id" placeholder="Bron">
                  <mat-option *ngFor="let source of filters.sources.data" [value]="source.id">
                    {{ source.name }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="formService.getFieldError('source_id')">
                  {{ formService.getFieldError('source_id') }}
                </mat-error>
                <mat-spinner *ngIf="filters.sources.isLoading" diameter="20"></mat-spinner>
              </mat-form-field>
              <mat-form-field #f14 [matTooltip]="getTooltipText(f14)">
                <mat-label>Actie</mat-label>
                <mat-select [formControl]="form.controls.action_id" placeholder="Actie">
                  <mat-option *ngFor="let action of filters.actions.data" [value]="action.id">
                    {{ action.name }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="formService.getFieldError('action_id')">
                  {{ formService.getFieldError('action_id') }}
                </mat-error>
                <mat-spinner *ngIf="filters.actions.isLoading" diameter="20"></mat-spinner>
              </mat-form-field>
              <mat-form-field #f15 [matTooltip]="getTooltipText(f15)">
                <mat-label>Strom</mat-label>
                <mat-select [formControl]="form.controls.current_id" placeholder="Strom">
                  <mat-option *ngFor="let current of filters.currents.data" [value]="current.id">
                    {{ current.name }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="formService.getFieldError('current_id')">
                  {{ formService.getFieldError('current_id') }}
                </mat-error>
                <mat-spinner *ngIf="filters.currents.isLoading" diameter="20"></mat-spinner>
              </mat-form-field>
              <mat-form-field #f16 [matTooltip]="getTooltipText(f16)">
                <mat-label>Invloed registratie</mat-label>
                <mat-select [formControl]="form.controls.impact_registration_id" placeholder="Invloed registratie">
                  <mat-option *ngFor="let impactRegistration of filters.impactRegistrations.data" [value]="impactRegistration.id">
                    {{ impactRegistration.name }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="formService.getFieldError('impact_registration_id')">
                  {{ formService.getFieldError('impact_registration_id') }}
                </mat-error>
                <mat-spinner *ngIf="filters.impactRegistrations.isLoading" diameter="20"></mat-spinner>
              </mat-form-field>
              <mat-form-field #f17 [matTooltip]="getTooltipText(f17)">
                <mat-label>Zaak</mat-label>
                <input matInput [formControl]="form.controls.outside_number">
                <mat-error *ngIf="formService.getFieldError('outside_number')">
                  {{ formService.getFieldError('outside_number') }}
                </mat-error>
              </mat-form-field>
            </ng-container>
          </div>
        </fury-scrollbar>
      </mat-tab>
      <mat-tab *ngIf="task && (authenticationService.user$ | async)?.permissions | hasPermission: ['tasks.view', 'tasks.handle']" label="AFHANDELING">
        <ng-template mat-tab-label>
          AFHANDELING
          <mat-icon *ngIf="tabWarning.includes('afhandeling') && task?.closed_at === null">warning</mat-icon>
        </ng-template>
        <fury-scrollbar class="overflow-container">
          <div class="task-panel-body" fxLayout="column">
            <ng-container *ngIf="task.resolution_notes?.length">
              <h2>Terugkoppeling taken</h2>
              <div class="note-container" *ngFor="let note of task.resolution_notes">
                <h3 class="note-header">
                  <div>
                    <div class="tag mat-green" *ngIf="note.handle === 'resolved'">Afgehandeld</div>
                    <div class="tag mat-red" *ngIf="note.handle === 'rejected'">Afgewezen</div>
                    <mat-icon>calendar_month</mat-icon>
                    {{ note.created_at | date:'dd-MM-yy HH:mm' }}
                    <div class="user">
                      <mat-icon>person</mat-icon>
                      {{ note.user?.name ?? 'Onbekend' }}
                    </div>
                  </div>
                </h3>
                <div *ngIf="note.note" [innerHTML]="note.note" class="note-content"></div>
                <div *ngIf="!note.note" class="note-content">-</div>
                <ng-container *ngIf="note.attachments?.total">
                  <fury-attachments [resolutionNote]="note" [(task)]="task" [class]="'wide'"></fury-attachments>
                </ng-container>
              </div>
              <mat-divider></mat-divider>
            </ng-container>
            <button *ngIf="['resolved', 'rejected'].indexOf(task.status.name) === -1"
                    [disabled]="showNoteWidget"
                    mat-flat-button class="mat-blue note-button" (click)="editNote('create')">
              <mat-icon>note</mat-icon>
              Notitie
            </button>
            <ng-container *ngIf="['resolved', 'rejected'].indexOf(task.status.name) === -1">
              <ng-container *ngIf="showNoteWidget">
                <mat-form-field #f18 [matTooltip]="getTooltipText(f18)">
                  <mat-label>Interne notitie</mat-label>
                  <textarea [formControl]="noteForm.controls.note" matInput maxlength="5000" rows="2"></textarea>
                  <input [formControl]="noteForm.controls.update_id" [value]="null" type="hidden">
                  <mat-hint align="end">
                    {{ noteForm.controls.note.value.length }} / 5000
                  </mat-hint>
                  <mat-error *ngIf="formService.getFieldError('note')">
                    {{ formService.getFieldError('note') }}
                  </mat-error>
                </mat-form-field>
                <div fxFlex fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="22px" fxLayoutGap.gt-sm="5px" fxLayoutAlign="space-between center">
                  <button (click)="editNote('cancel')" class="mat-grey" mat-flat-button type="button">
                    <mat-icon>cancel</mat-icon>
                    Sluiten
                  </button>
                  <button (click)="editNote('save')" color="primary" mat-flat-button type="button">
                    <mat-icon>save</mat-icon>
                    Opslaan
                  </button>
                </div>
              </ng-container>
              <mat-divider></mat-divider>
            </ng-container>
            <ng-container *ngIf="task.notes.length">
              <h2>Interne notitie(s) taak</h2>
              <div *ngFor="let note of task.notes" class="note-container">
                <h3 class="note-header">
                  <div>
                    <mat-icon>calendar_month</mat-icon>
                    {{ note.created_at | date:'dd-MM-yy HH:mm' }}
                    <div class="user">
                      <mat-icon>person</mat-icon>
                      {{ note.user?.name ?? 'Onbekend' }}<small *ngIf="note.is_updated"> (aangepast)</small></div>
                  </div>
                  <button (click)="editNote('edit', note)" class="link" mat-button type="button"
                          *ngIf="['resolved', 'rejected'].indexOf(task.status.name) === -1 && note.user_id === (authenticationService.user$ | async).id">
                    <mat-icon>edit</mat-icon>
                    Aanpassen
                  </button>
                </h3>
                <div [innerHTML]="note.note" class="note-content"></div>
              </div>
              <mat-divider></mat-divider>
            </ng-container>
            <ng-container *ngIf="task.forwarded?.length">
              <h2>Kopie van taak verstuurd naar e-mail</h2>
              <div class="note-container" *ngFor="let note of task.forwarded">
                <h3 class="note-header">
                  <div>
                    <mat-icon>calendar_month</mat-icon>
                    {{ note.sent_at | date:'dd-MM-yy HH:mm' }}
                    <div class="user">
                      <mat-icon>mail</mat-icon>
                      <ng-container *ngIf="!note.recipient && note.address_book">
                        {{ note.address_book.name }} ({{ note.address_book.email }})
                      </ng-container>
                      <ng-container *ngIf="note.recipient">{{ note.recipient }}</ng-container>
                    </div>
                  </div>
                </h3>
                <div *ngIf="note.note" [innerHTML]="note.note" class="note-content"></div>
                <div *ngIf="!note.note" class="note-content">-</div>
              </div>
              <mat-divider></mat-divider>
            </ng-container>
            <ng-container *ngIf="task.reassign_notes?.length">
              <h2>Nieuw toegewezen taak</h2>
              <div class="note-container" *ngFor="let note of task.reassign_notes">
                <h3 class="note-header">
                  <div>
                    <mat-icon>calendar_month</mat-icon>
                    {{ note.created_at | date:'dd-MM-yy HH:mm' }}
                    <div class="user">
                      <mat-icon>person</mat-icon>
                      {{ note.user?.name ?? 'Onbekend' }}
                    </div>
                  </div>
                </h3>
                <div *ngIf="note.note" [innerHTML]="note.note" class="note-content"></div>
                <div *ngIf="!note.note" class="note-content">-</div>
              </div>
              <mat-divider></mat-divider>
            </ng-container>
            <ng-container *ngIf="task.reopen_notes?.length">
              <h2>Verklaring taak heropenen</h2>
              <div class="note-container" *ngFor="let note of task.reopen_notes">
                <h3 class="note-header">
                  <div>
                    <mat-icon>calendar_month</mat-icon>
                    {{ note.created_at | date:'dd-MM-yy HH:mm' }}
                    <div class="user">
                      <mat-icon>person</mat-icon>
                      {{ note.user?.name ?? 'Onbekend' }}
                    </div>
                  </div>
                </h3>
                <div *ngIf="note.note" [innerHTML]="note.note" class="note-content"></div>
                <div *ngIf="!note.note" class="note-content">-</div>
              </div>
              <mat-divider></mat-divider>
            </ng-container>
            <div *ngIf="canShowHandleButtons" fxFlex fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="22px" fxLayoutGap.gt-sm="5px">
              <button (click)="setHandleValue('resolved')" [disabled]="handlingForm.controls.handle.value === 'resolved'"
                      [class.checked]="handlingForm.controls.handle.value === 'rejected'"
                      mat-flat-button color="primary" fxFlex="100" fxFlex.gt-sm="50">
                <mat-icon>check_circle</mat-icon>
                Taak afhandelen
              </button>
              <button (click)="setHandleValue('rejected')" [disabled]="handlingForm.controls.handle.value === 'rejected'"
                      [class.checked]="handlingForm.controls.handle.value === 'resolved'"
                      mat-flat-button color="accent" fxFlex="100" fxFlex.gt-sm="50">
                <mat-icon>cancel</mat-icon>
                Taak afwijzen
              </button>
            </div>
            <ng-container *ngIf="handlingForm.controls.handle.value">
              <mat-divider></mat-divider>
              <mat-form-field #f256 [matTooltip]="getTooltipText(f256)">
                <mat-label>
                  <span>Selecteer een standaard reactie</span>
                </mat-label>
                <mat-select [formControl]="handlingForm.controls.standard_reaction_id">
                  <mat-option [value]="null">Geen</mat-option>
                  <mat-option *ngFor="let option of filters.standardReactions.data" [value]="option.id">
                    {{ option.name }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="formService.getFieldError('standard_reaction_id')">
                  {{ formService.getFieldError('standard_reaction_id') }}
                </mat-error>
                <mat-spinner *ngIf="filters.standardReactions.isLoading" diameter="20"></mat-spinner>
              </mat-form-field>
              <div class="fake-mat-form-field quill">
                <mat-label>Motiveer deze actie</mat-label>
                <div class="fake-mat-form-field-content">
                  <div class="quill-container">
                    <quill-editor [formControl]="handlingForm.controls.note"
                                  [modules]="quillService.minimal.toolbar"
                                  [formats]="quillService.minimal.formats"
                                  [styles]="{ flex: '1 1 auto' }"
                                  (onContentChanged)="quillService.maxLength($event, 5000)"
                                  [maxLength]="5000"
                                  (onEditorCreated)="quillService.quillEditor = $event"
                                  [sanitize]="true"
                                  class="quill"
                                  fxFlex="auto"
                                  fxLayout="column"
                                  placeholder="Motiveer deze actie"></quill-editor>
                  </div>
                </div>
                <mat-error *ngIf="quillService.uploadError">
                  {{ quillService.uploadError }}
                </mat-error>
              </div>
              <div *ngIf="canShowHandleButtons" fxFlex fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="22px" fxLayoutGap.gt-sm="5px" fxLayoutAlign="space-between center">
                <div>
                  <button (click)="setHandleValue(null)" mat-flat-button class="mat-grey">
                    <mat-icon>cancel</mat-icon>
                    Sluiten
                  </button>
                </div>
                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="22px" fxLayoutGap.gt-sm="5px">
                  <button (click)="uploadHandlingAttachmentsInput.open()" class="mat-blue" mat-flat-button type="button">
                    <mat-icon>attachment</mat-icon>
                  </button>
                  <button *ngIf="handlingForm.controls.handle.value === 'resolved'" (click)="handleTask()" mat-flat-button color="primary">
                    <mat-icon>check_circle</mat-icon>
                    Taak afhandelen
                  </button>
                  <button *ngIf="handlingForm.controls.handle.value === 'rejected'" (click)="handleTask()" mat-flat-button color="accent">
                    <mat-icon>cancel</mat-icon>
                    Taak afwijzen
                  </button>
                </div>
              </div>
              <div *ngIf="canShowHandleButtons">
                <mat-form-field style="height: 0 !important; overflow: hidden;">
                  <mat-label>
                    <span>Selecteer de bijlage(n) die u wilt uploaden</span>
                  </mat-label>
                  <ngx-mat-file-input
                      #uploadHandlingAttachmentsInput
                      (change)="detectHandlingAttachments($event)"
                      [formControl]="handlingForm.controls.attachmentsContainer"
                      [multiple]="true"></ngx-mat-file-input>
                  <mat-error *ngIf="formService.getFieldError('attachments')">
                    {{ formService.getFieldError('attachments') }}
                  </mat-error>
                </mat-form-field>
                <div fxLayout="column">
                  <ng-container #handlingAttachmentsPlaceholder></ng-container>
                </div>
              </div>
            </ng-container>
            <div *ngIf="showReopenWidget" fxFlex fxLayout="column">
              <h2>Heropenen taak</h2>
              <p>Wilt u doorgaan met de taak te heropenen? Let op: bij het heropenen moet de taak weer in behandeling worden genomen en
                afgehandeld waar de melder wordt geïnformeerd. Gebruik deze optie niet indien er alleen gegevens moeten worden aangepast in de
                taak.</p>
              <div class="fake-mat-form-field quill">
                <mat-label>Motiveer waarom je deze taak wilt afwijzen?</mat-label>
                <div class="fake-mat-form-field-content">
                  <div class="quill-container">
                    <quill-editor [formControl]="reopenForm.controls.note"
                                  [modules]="quillService.minimal.toolbar"
                                  [formats]="quillService.minimal.formats"
                                  [styles]="{ flex: '1 1 auto' }"
                                  (onContentChanged)="quillService.maxLength($event, 5000)"
                                  [maxLength]="5000"
                                  (onEditorCreated)="quillService.quillEditor = $event"
                                  [sanitize]="true"
                                  class="quill"
                                  fxFlex="auto"
                                  fxLayout="column"
                                  placeholder="Motiveer waarom je deze taak wilt afwijzen?"></quill-editor>
                  </div>
                </div>
                <div class="mat-form-field-appearance-fill">
                  <div class="mat-form-field-subscript-wrapper">
                    <div class="mat-form-field-hint-wrapper">
                      <div class="mat-form-field-hint-spacer"></div>
                      <mat-hint align="end">
                        {{ reopenForm.controls.note.value?.length }} / 5000
                      </mat-hint>
                    </div>
                  </div>
                </div>
                <mat-error *ngIf="quillService.uploadError">
                  {{ quillService.uploadError }}
                </mat-error>
              </div>
              <div fxFlex fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="22px" fxLayoutGap.gt-sm="5px" fxLayoutAlign="space-between center">
                <button (click)="toggleReopen()" class="mat-grey" mat-flat-button type="button">
                  <mat-icon>cancel</mat-icon>
                  Sluiten
                </button>
                <button (click)="reopenTask()" color="primary" mat-flat-button type="button">
                  <mat-icon>save</mat-icon>
                  Heropenen
                </button>
              </div>
            </div>
          </div>
        </fury-scrollbar>
      </mat-tab>
      <mat-tab *ngIf="task" label="GESCHIEDENIS">
        <fury-task-editor-task-history [activatedView]="historyViewActivated" [taskId]="taskId"></fury-task-editor-task-history>
      </mat-tab>
    </form>
  </mat-tab-group>
  <div *ngIf="taskPanelService.editorType === 'update' && !task && !isLoading" fxFlex fxLayoutAlign="center center">
    <h1>Geen taak gevonden!</h1>
  </div>
  <div class="task-panel-footer" fxLayoutAlign="space-between center">
    <fury-page-header-buttons [buttons]="bottomLeftButtons"></fury-page-header-buttons>
    <fury-page-header-buttons [buttons]="bottomRightButtons"></fury-page-header-buttons>
  </div>
</div>
